<template>
  <a-col
    v-if="config.type === 'datepicker'"
    :span="12"
  >
    <a-form-item label="选择粒度">
      <a-select
        v-model:value="config.picker"
        allow-clear
        placeholder="默认日"
        :options="[
          { value: 'date', label: '日' },
          { value: 'week', label: '周' },
          { value: 'month', label: '月' },
          { value: 'quarter', label: '季' },
          { value: 'year', label: '年' },
        ]"
      />
    </a-form-item>
  </a-col>
  <a-col
    v-if="config.type === 'datepicker'"
    :span="12"
  >
    <a-form-item label="显示时间">
      <a-switch
        v-model:checked="config.showTime"
        checked-children="有"
        un-checked-children="无"
      />
    </a-form-item>
  </a-col>
  <a-col :span="12">
    <a-form-item label="时间格式">
      <a-input
        v-model:value="config.format"
        allow-clear
      />
    </a-form-item>
  </a-col>
  <a-col :span="12">
    <a-form-item label="传值格式">
      <a-input
        v-model:value="config.valueFormat"
        allow-clear
      />
    </a-form-item>
  </a-col>
</template>

<script setup lang="ts">
/* 日期时间类配置（共享）：picker/showTime（仅 datepicker）+ format/valueFormat。 */
defineProps<{ config: any }>();
</script>
